import React from "react";
import { formatEventPriceLabel, isPaidEvent } from "../shared/utils/eventPaymentMode";

/**
 * Scannable Free (green) vs Paid (gold/amber) price badge.
 *
 * @param {{ event?: object|null, className?: string }} props
 */
export default function EventPriceBadge({ event = null, className = "" }) {
  const paid = isPaidEvent(event);
  const label = formatEventPriceLabel(event);
  const tone = paid ? "paid" : "free";
  const rootClass = ["event-price-badge", `event-price-badge--${tone}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={rootClass} role="status" aria-label={`Price: ${label}`}>
      {label}
    </span>
  );
}
